import { DialogContent, DialogOverlay } from '@reach/dialog';

import styled, { css } from '@lokalise/ui/styled';
import { color, mediaQuery, radius, spacing, typography, variants, zIndex } from '@lokalise/ui/theme';

export type ModalSize = 'small' | 'default' | 'wide';

const spacingOnLargeScreens = 7;
const spacingOnSmallScreens = 5;

export const Inner = styled.div`
    background-color: ${color('background.primary')};
    border-radius: ${radius('md')};
    ${typography('description')}
    color: ${color('content.primary')};
    position: relative;
`;

export const Header = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: ${spacing(spacingOnSmallScreens)};

    ${mediaQuery.min('sm')} {
        padding: ${spacing(spacingOnLargeScreens)};
    }
`;

export const Title = styled.h2`
    ${typography('heading4')}
    color: ${color('content.primary')};
    width: 100%;
    margin: 0;
`;

export const Section = styled.div`
    padding: ${spacing(0, spacingOnSmallScreens, spacingOnSmallScreens, spacingOnSmallScreens)};

    ${mediaQuery.min('sm')} {
        padding: ${spacing(0, spacingOnLargeScreens, spacingOnLargeScreens, spacingOnLargeScreens)};
    }
`;

export const Actions = styled.div`
    padding-top: ${spacing(6)};

    ${mediaQuery.min('sm')} {
        padding-top: ${spacing(7)};
    }
`;

// https://reach.tech/styling/
export const disableReachDialogWarning = `
    :root {
        --reach-dialog: 1;
    }
`;

export const StyledDialogOverlay = styled(DialogOverlay)`
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    z-index: ${zIndex('modal')};
`;

export const StyledDialogContent = styled(DialogContent)<{ size: ModalSize }>`
    box-sizing: border-box;
    background-color: transparent;
    position: relative;
    margin: ${spacing(3)} auto;
    padding: ${spacing(0, 3)};

    ${mediaQuery.min('sm')} {
        margin: ${spacing(7)} auto;
        padding: ${spacing(0, 4)};
    }
    width: 100%;
    outline: none;

    ${variants('size', {
        small: css`
            max-width: 332px; // Width is 300px but take side padding into consideration
        `,
        default: css`
            max-width: 632px; // Width is 600px but take side padding into consideration
        `,
        wide: css`
            max-width: 865px; // Width is 833px but take side padding into consideration
        `,
    })}
`;
